import React from 'react';
import Course from './Container/CourseTable';

export default [
    {
        path: '/course',
        exact: true,
        component: () => <Course />
    },
];